import { SeahorseMenuItem } from '@seahorse/layout';

export const navigation: SeahorseMenuItem[] = [
  {
    route: 'dashboard',
    label: 'layout.sidebar.dashboard',
    icon: 'fa-gauge',
    permissions: 'superusers.superuser',
    order: 0,
  },
  {
    route: 'customers',
    label: 'layout.sidebar.customers',
    icon: 'fa-building',
    permissions: 'superusers.superuser',
    order: 1,
  },
  {
    route: 'seahorse-modules/overview',
    label: 'layout.sidebar.seahorseModules',
    icon: 'fa-server',
    permissions: 'superusers.superuser',
    order: 2,
  },
  {
    route: 'nautical/ship/overview',
    label: 'layout.sidebar.ships',
    icon: 'fa-ship',
    permissions: 'superusers.superuser',
    order: 3,
  },
  {
    route: 'nautical/map',
    label: 'layout.sidebar.map',
    icon: 'fa-map',
    permissions: 'superusers.superuser',
    order: 3,
  },
  {
    route: 'feature-releases/overview',
    label: 'layout.sidebar.featureRelease',
    icon: 'fa-rocket',
    permissions: 'superusers.superuser',
    order: 4,
  },
  {
    route: 'master-data',
    label: 'layout.sidebar.masterData',
    icon: 'fa-table',
    permissions: 'superusers.superuser',
    order: 5,
  },
  {
    route: 'logs',
    label: 'layout.sidebar.logs',
    icon: 'fa-list',
    permissions: 'superusers.superuser',
    order: 6,
  },
  {
    route: 'system-messages',
    label: 'layout.sidebar.systemMessages',
    icon: 'fa-bullhorn',
    permissions: 'superusers.superuser',
    order: 7,
  },
  {
    route: 'invoice-flow-executions',
    label: 'layout.sidebar.invoiceFlowExecutions',
    icon: 'fa-file-invoice-dollar',
    permissions: 'superusers.superuser',
    order: 8,
  },
  {
    route: 'notifications',
    label: 'layout.sidebar.notifications',
    icon: 'fa-envelope',
    permissions: 'superusers.superuser',
    order: 9,
  },
  // {
  //   route: 'su/home',
  //   label: 'layout.sidebar.admin',
  //   icon: 'fa-user-secret',
  //   permissions:
  //     'superusers.superuser_nautical_geography,superusers.superuser_nautical_port_visits,superusers.superuser_nautical_ship',
  //   order: 17,
  //   isSecondary: true,
  // },
];
